import React from "react";
import "./Footer.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Logoaspen from "../../media/aspenlogo.svg";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="footer-main">
      <footer className="footer text-light pt-5 pb-3">
        <div className="container">
          <div className="row">
            {/* Logo & Address */}
            <div className="col-lg-3 col-md-6 mb-4">
              <h4 className="footer-logo mb-3 d-flex align-items-center">
                <img
                  src={Logoaspen}
                  alt="Aspen Logo"
                  className="footer-logo-img me-2"
                />
              </h4>
              <p className="footer-location text-white">
                4340 S Abilene Cir
                <br /> Aurora CO 80015
              </p>
              <div className="d-flex gap-3 footer-socials">
                <div className="icon-footer-div">
                  <a href="https://www.facebook.com/share/19R41YJQK4/?mibextid=wwXIfr">
                    <i className="bi bi-facebook"></i>
                  </a>
                </div>
                <div className="icon-footer-div">
                  <a href="#">
                    <i className="bi bi-twitter"></i>
                  </a>
                </div>
                <div className="icon-footer-div">
                  <a href="#">
                    <i className="bi bi-instagram"></i>
                  </a>
                </div>
                <div className="icon-footer-div">
                  <a href="#">
                    <i className="bi bi-linkedin"></i>
                  </a>
                </div>
              </div>
            </div>
            {/* Quick Links */}
            <div className="col-lg-3 col-md-6 mb-4">
              <h5 className="footer-heading">Quick Links</h5>
              <ul className="list-unstyled">
                <li>
                  <Link to="/about">→ About Us</Link>
                </li>
                <li>
                  <a
                    href="https://aspensraccounting.blogspot.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    → Blog
                  </a>
                </li>
                <li>
                  <Link to="/contact">→ Contact Us</Link>
                </li>
              </ul>
            </div>
            {/* Our Services */}
            <div className="col-lg-3 col-md-6 mb-4">
              <h5 className="footer-heading">Our Services</h5>
              <ul className="list-unstyled">
                <li>
                  <Link to="/accounting">→ Accounting</Link>
                </li>
                <li>
                  <Link to="/consulting">→ Consulting</Link>
                </li>
                <li>
                  <Link to="/grants">→ Grants</Link>
                </li>
                <li>
                  <Link to="/taxes">→ Taxes</Link>
                </li>
              </ul>
            </div>
            {/* Business Hours */}
            {/* Why Choose Aspen SR */} {/* ✅ Replacing Business Hours */}
            {/* Visit Our Office – Map Location */}
            {/* Our Commitment */}
            <div className="col-lg-3 col-md-6 mb-4">
              <h5 className="footer-heading text-white">Our Commitment</h5>
              <p className="text-white small">
                At Aspen SR, we believe in ethics, clarity, and long-term value
                for every client — no matter the size of your business.
              </p>
            </div>
          </div>
          <div className="footer-bottom mt-4 pt-3 d-flex flex-column flex-md-row justify-content-between align-items-center">
            <p className="footer-anrika mb-2 mb-md-0 text-white">
              © {new Date().getFullYear()} All Rights Reserved.
            </p>
            <p className="mb-0 text-white anrika-right">
              Designed by{" "}
              <a
                className="anrika-a text-white"
                href="https://anrikatech.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Anrika Tech
              </a>
            </p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/17204127990"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <i className="bi bi-whatsapp"></i>
      </a>
    </div>
  );
};

export default Footer;
